// extracted by mini-css-extract-plugin
export default {"mainDiv":"AboutMe_mainDiv__hLIa-","photoDetailDiv":"AboutMe_photoDetailDiv__I+ERu","myDetail":"AboutMe_myDetail__L0U0w","photo":"AboutMe_photo__tCszi"};